// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","banner":"WarmAgentsPromoBanner-module__banner--yU"};